import { render, staticRenderFns } from "./LegalTermsImaPlus.vue?vue&type=template&id=207fe65e&scoped=true&"
import script from "./LegalTermsImaPlus.vue?vue&type=script&lang=js&"
export * from "./LegalTermsImaPlus.vue?vue&type=script&lang=js&"
import style0 from "./LegalTermsImaPlus.vue?vue&type=style&index=0&id=207fe65e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207fe65e",
  null
  
)

export default component.exports